import { cn } from "@/lib/utils";
import { EyeOff } from "lucide-react";

interface ImageFallbackProps {
  /**
   * Additional CSS classes to apply to the container
   */
  className?: string;
  /**
   * Fallback message to display
   * @default "Kein Bild verfügbar"
   */
  message?: string;
  /**
   * Visual density for the fallback content.
   * @default "md"
   */
  size?: "sm" | "md";
}

/**
 * Image fallback component displayed when no image is available.
 * Shows an eye-off icon with a question mark badge and a message.
 */
export default function ImageFallback({
  className,
  message = "Kein Bild verfügbar",
  size = "md",
}: ImageFallbackProps) {
  const isSmall = size === "sm";

  return (
    <div
      className={cn(
        "flex aspect-video w-full items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100",
        className
      )}
    >
      <div
        className={cn(
          "flex flex-col items-center text-gray-400",
          isSmall ? "gap-1" : "gap-2"
        )}
      >
        <div className="relative">
          <div
            className={cn(
              "flex items-center justify-center rounded-full bg-gray-300",
              isSmall ? "h-8 w-8" : "h-16 w-16"
            )}
          >
            <EyeOff className={isSmall ? "h-4 w-4" : "h-8 w-8"} />
          </div>
          <div
            className={cn(
              "absolute flex items-center justify-center rounded-full bg-gray-400",
              isSmall
                ? "-top-0.5 -right-0.5 h-3.5 w-3.5"
                : "-top-1 -right-1 h-6 w-6"
            )}
          >
            <span
              className={cn(
                "font-medium text-white",
                isSmall ? "text-[9px]" : "text-xs"
              )}
            >
              ?
            </span>
          </div>
        </div>
        <span
          className={cn("font-medium", isSmall ? "text-[10px]" : "text-sm")}
        >
          {message}
        </span>
      </div>
    </div>
  );
}
